import types from "../../typesBoundaries.json";
import state from "../../defaultBoundariesState";
import { fromJS } from "immutable";

const initialState = state.dailyQs;
export default function app(state = initialState, action) {
  switch (action.type) {
    case types.GET_DAILYQS_SUCCESS:
      return state.setIn(["data"], fromJS(action.payload));
    case types.GET_DAILYQS_ERROR:
      return state.setIn(
        ["error"],
        fromJS(
          action.payload.response
            ? action.payload.response.error
            : action.payload.message
        )
      );
    default:
      return state;
  }
}
